<template>
  <div class="flex responsive-image">
    <div
      class="thumbnail"
      :style="{
        backgroundImage: `url(${getProductImageLowRes(
          product.imageSources[0],
          product.store
        )})`
      }"
    >
      <img
        id="img"
        class="img"
        sizes="(max-width: 767px) calc(50vw - 36px), (min-width: 768px) and (max-width: 1280px) calc(25vw - 64px), 284px"
        :src="
          `${getProductImageLowRes(product.imageSources[0], product.store)}`
        "
        @error="imageError"
      />
    </div>
  </div>
</template>

<script>
import { productImageResizer } from "../../mixins";
import $ from "jquery";
export default {
  name: "responsive-image",
  props: { product: Object },
  mixins: [productImageResizer],
  data() {
    return {
      error: false
    };
  },
  methods: {
    imageError() {
      this.error = true;
    }
  },
  mounted() {
    var width = -1;
    var ratio = 1.35;

    $(".img").each(function() {
      width = width > $(this).width() ? width : $(this).width();
    });

    $(".img").each(function() {
      $(this).height(ratio * width);
    });

    $(window).resize(function() {
      var width = -1;
      $(".img").each(function() {
        width = width > $(this).width() ? width : $(this).width();
      });
      $(".img").each(function() {
        $(this).height(ratio * width);
      });
    });
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.thumbnail {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  width: 100%;

  img {
    visibility: hidden;
    width: 100%;
  }
}
</style>
